import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design/tokens.css';
import './styles/design/layout.css';
import './styles/design/components.css';
import './styles/design/shipping.css';
import './styles/design/overview.css';
import './styles/design/mobile.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryProvider } from './context/QueryProvider';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
